import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=71231f94&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "./Results.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&id=71231f94&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71231f94",
  null
  
)

export default component.exports